<!-- 解决方案 -->
<template>
  <div class="academy-basePanel-container">
    <div class="academy-basePanel-wrapper">
      <header
        class="academy-basePanel-hd"
        v-scroll-animate="{ animation: 'fadeInUp' }"
      >
        <h2 class="academy-basePanel-title">
          {{ baseInfo[type].title }}
        </h2>
        <h3 class="academy-basePanel-subTitle">
          <span class="strong">{{ type }}</span>
          {{ baseInfo[type].subTitle }}
        </h3>
        <h4 class="academy-basePanel-desc">{{ baseInfo[type].desc }}</h4>
        <div class="academy-basePanel-btn">
          <el-button
            class="academy-btn"
            @click="toHelp"
            style="margin-right: 24px"
          >
            View Help Documentation
          </el-button>
          <el-button class="academy-btn" @click="toSoftware">
            Download Free Trial Version
          </el-button>
          <!-- <DownLoad
            btnLabel="Download Free Trial Version"
            :fileUrl="freeTrialUrl"
            :fileName="freeTrialName"
            icon=""
          /> -->
        </div>
      </header>
      <article class="academy-basePanel-bd">
        <header
          class="basePanel-video-hd academy-basePanel-subTitle"
          v-scroll-animate="{ animation: 'fadeInUp' }"
        >
          <span class="aside">
            <span class="strong">{{ type }}</span>
            Tutorial Videos！
          </span>
          <el-button class="academy-btn" @click="toVideo">
            More Videos
          </el-button>
        </header>
        <EmptyPage
          v-if="videoList.length == 0"
          :name="'No data available at the moment!'"
        />
        <template v-else>
          <el-row
            :gutter="30"
            class="basePanel-video-bd"
            v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
          >
            <el-col :span="8" v-for="video in videoList" :key="video.id">
              <img
                class="video-cover"
                :src="video.cover"
                alt=""
                @click="playVideo(video)"
              />
              <el-tooltip :content="video.title" placement="top-start">
                <h4 class="video-title" @click="playVideo(video)">
                  {{ video.title }}
                </h4>
              </el-tooltip>
              <h5 class="video-desc">{{ video.desc }}</h5>
              <!-- <el-button class="academy-btn" @click="playVideo(video)">
                Play Video
              </el-button> -->
            </el-col>
          </el-row>
        </template>
      </article>
      <VideoModal
        :dialogVisible.sync="dialogVisible"
        :video="video"
      ></VideoModal>
    </div>
  </div>
</template>

<script>
import DownLoad from "@/components/DownLoad";
import VideoModal from "@/components/videoModal.vue";
import EmptyPage from "@/components/EmptyPage.vue";
export default {
  name: "BaseAcademy",
  components: { DownLoad, VideoModal, EmptyPage },
  props: {
    type: {
      type: String,
      default: "AIRoad",
    },
    helpDocument: {
      type: String,
      default: "",
    },
    freeTrialUrl: {
      type: String,
      default: "",
    },
    freeTrialName: {
      type: String,
      default: "",
    },
    moreVideoUrl: {
      type: String,
      default: "",
    },
    videoList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      baseInfo: {
        AIRoad: {
          title: "Quickly Master AIRoad, Start Here",
          subTitle: "Help Documentation！",
          desc: "AIRoad, powered by our self-developed BIM engine, uses GIS, aerial surveying, and remote sensing data to construct digital terrain models, enabling rapid parametric and intelligent design. Through dynamic and interactive routing, it automatically generates model designs. By continuously leveraging AI language models and content generation technologies, AIRoad enhances creative designs, visual representation, and drafting support, improving design efficiency. It boosts design efficiency by 8–10 times and overall design efficiency by 20–30%.",
        },
        EICAD: {
          title: "Quickly Master EICAD, Start Here",
          subTitle: "Help Documentation！",
          desc: 'After years of development, EICAD now covers the fields of highways, municipal engineering, and rail transit. It is a comprehensive digital design software suite containing multiple professional modules, including field surveys, digital ground models, routes, interchanges, subgrades and pavements, bridges, tunnels, traffic engineering, and water supply and drainage systems. EICAD design software consistently adheres to the concept of "improving design efficiency and quality" by continuously innovating and enriching its functionality to create value for clients and provide high-quality digital software products for infrastructure construction.',
        },
        VRRoad: {
          title: "Quickly Master VRRoad, Start Here",
          subTitle: "Help Documentation！",
          desc: "VRRoad, the road driving simulation and safety evaluation system, is a software and hardware integrated solution aimed at road geometric design and safety assessment. The system quickly imports design results and generates a simulation road network that accurately describes lanes and roadside features in accordance with the OpenDrive standard. It facilitates the synchronous collection of complete experimental data and supports multi-degree-of-freedom motion platform driving, providing a realistic driving experience.",
        },
        Report3D: {
          title: "Quickly Master Report3D, Start Here",
          subTitle: "Help Documentation！",
          desc: "Report3D is a digital reporting system developed based on game engine technology, designed as a reporting tool for multiple types of projects. It enables the efficient creation of real-time rendered scenes and complex PPT creation, allowing users to view and interact with digital twin models in real time. With no complex installation or configuration required, it lowers the barrier to using 3D scenes, enabling more people to easily participate in 3D scene construction and PPT presentations. The system offers a 3D, dynamic, interactive reporting method, exploring new ways to present results in the digital age. It tells the project story in the form of a short film, creating an immersive experience.",
        },
      },
      dialogVisible: false,
      video: undefined,
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    toVideo() {
      this.moreVideoUrl && window.open(this.moreVideoUrl, "_blank");
    },
    toHelp() {
      // this.helpDocument && window.open(this.helpDocument, "_blank");
      this.$uniFun.openInCurrentTab("/download?type=manual");
    },
    toSoftware() {
      // this.helpDocument && window.open(this.helpDocument, "_blank");
      this.$uniFun.openInCurrentTab("/download?type=software");
    },
    playVideo(video) {
      let videoFormat = [".mp4", ".webm", "ogg", ".MP4"];
      // 判断地址是页面还是视频
      const url = new URL(video.videoUrl);
      const pathname = url.pathname;
      const isSupportedFormat = videoFormat.some((format) =>
        pathname.endsWith(format),
      );
      if (isSupportedFormat) {
        // 符合格式的视频，弹窗展示
        this.dialogVisible = true;
        this.video = video;
      } else {
        // 不符合的，跳转标签页
        window.open(video.videoUrl, "_blank");
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/common.scss";
.academy-basePanel-container {
  background: #fff;
  .academy-basePanel-wrapper {
    width: 1049px;
    margin: 0 auto;
    padding: 40px 0;
    border-bottom: 1px solid #d8d8d8;
  }
  .academy-basePanel-subTitle {
    margin-bottom: 12px;
    font-family: Arial, Arial;
    font-size: 18px;
    color: #1d1d1f;
    line-height: 24px;
    text-align: left;
    font-weight: normal;
    font-style: normal;
    .strong {
      padding-right: 4px;
      font-weight: bold;
    }
  }
  .academy-basePanel-hd {
    margin-bottom: 40px;
    .academy-basePanel-title {
      margin-bottom: 40px;
      font-weight: bold;
      font-size: 24px;
      color: #1d1d1f;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }

    .academy-basePanel-desc {
      margin-bottom: 16px;
      font-weight: 400;
      font-size: 12px;
      color: #1d1d1f;
      line-height: 24px;
      text-align: justify;
      font-style: normal;
    }
  }

  .academy-btn {
    padding: 8px 12px;
    border-color: #1d1d1f;
    color: #1d1d1f;
    font-size: 14px;
    &:hover {
      background: transparent;
      border-color: #0035fb;
      color: #0035fb;
    }
  }

  .academy-basePanel-bd {
    font-weight: 400;
    font-size: 18px;
    color: #333;
    line-height: 40px;
    text-align: justify;
    font-style: normal;
  }
  .basePanel-video-hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
  }
  .basePanel-video-bd {
    .video-title {
      margin-bottom: 12px;
      font-weight: bold;
      font-size: 16px;
      color: #1d1d1f;
      line-height: 24px;
      text-align: left;
      font-style: normal;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        transform: scale(1.05);
      }
      @extend .text-truncate-multiline;
      --line-clamp: 1;
    }
    .video-desc {
      height: 40px;
      margin-bottom: 12px;
      font-weight: 400;
      font-size: 12px;
      color: #1d1d1f;
      line-height: 20px;
      text-align: justify;
      font-style: normal;
      @extend .text-truncate-multiline;
      --line-clamp: 2;
    }
    .video-cover {
      width: 100%;
      height: 200px;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        transform: scale(1.05);
      }
    }
  }
}
</style>
<style lang="scss">
.academy-basePanel-container {
  .empty_page .empty {
    margin-top: 0 !important;
    padding-bottom: 0 !important;
  }
}
</style>
